import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './styles/components/matchbox.css';
import './styles/components/chat.css';
import './styles/components/podium.css';
import './styles/components/players.css';
import './styles/components/tournaments.css';
import './styles/components/hall-of-fame.css';
import './styles/components/ladders.css';
import './styles/components/board.css';
import Players from "./pages/Players";
import "./util/i18n";
import Navigation from "./components/Navigation";
import Tournaments from "./pages/Tournaments";
import TournamentDetail from "./pages/TournamentDetail";
import PlayerDetail from "./pages/PlayerDetail";
import MatchDetail from "./pages/MatchDetail";
import Homepage from "./pages/Homepage";
import Myreg from "./pages/Myreg";
import {useTranslation} from "react-i18next";
import Changelog from "./pages/Changelog";
import Administration from "./pages/Administration";
import About from "./pages/about/About";
import Chat from "./pages/Chat";
import HallOfFame from "./pages/HallOfFame";
import Board from "./pages/Board";
import UnofficialLadders from "./pages/UnofficialLadders";
import NewLadder from "./pages/NewLadder";
import LadderDetail from "./pages/LadderDetail";
import LadderSettings from "./pages/LadderSettings";
import { useTheme } from "./context/ThemeContext";
import { ChatSocketProvider } from "./context/ChatSocketContext";

function App() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  return (
    <div className={`App theme-${theme}`} style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)', minHeight: '100vh' }}>
      <ChatSocketProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigation />}>
            <Route index element={<Homepage />} />
            <Route path="players" element={<Players />} />
            <Route path="players/:id" element={<PlayerDetail />} />
            <Route path="tournaments" element={<Tournaments />} />
            <Route path="tournaments/:id" element={<TournamentDetail />} />
            <Route path="matches/:id" element={<MatchDetail />} />
            <Route path="ladders/unofficial" element={<UnofficialLadders />} />
            <Route path="ladders/new" element={<NewLadder />} />
            <Route path="ladders/:id" element={<LadderDetail />} />
            <Route path="ladders/:id/settings" element={<LadderSettings />} />
            <Route path="news" element={<Changelog />} />
            <Route path="about" element={<About />} />
            <Route path="hall-of-fame" element={<HallOfFame />} />
            <Route path="chat" element={<Chat />} />
            <Route path="board" element={<Board />} />
            <Route path="admin" element={<Administration />} />
            <Route path="myreg" element={<Myreg />} />
            <Route path="*" element={<h3 style={{padding: "5rem"}}>{t("notFound")}</h3>} />
          </Route>
        </Routes>
      </BrowserRouter>
      </ChatSocketProvider>
    </div>
  );
}

export default App;
